// extracted by mini-css-extract-plugin
export default {"group":"_-_-record-it-components-src-cardList-CardListItemGroup-__group","label":"_-_-record-it-components-src-cardList-CardListItemGroup-__label"};